const ComplementoInteresesRules = {
  SistFinanciero : [
    'required',
    'string',
    'in:SI,NO',
  ],
  RetiroAORESRetInt : [
    'required',
    'string',
    'in:SI,NO',
  ],
  OperFinancDerivad : [
    'required',
    'string',
    'in:SI,NO',
  ],
  MontIntNominal : [
    'required',
    'decimal:6',
  ],
  MontIntReal : [
    'required',
    'decimal:6',
  ],
  Perdida : [
    'required',
    'decimal:6',
  ],
};

export default ComplementoInteresesRules;

